var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignToImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4453_9837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0.602812C18 0.602812 18 0.722812 18 0.842812C16.32 6.36281 14.76 12.0028 13.08 17.5228C12.96 17.7628 12.96 18.0028 12.6 18.0028C12.36 18.0028 12.12 17.8828 12 17.6428C10.8 15.2428 9.59998 12.8428 8.39998 10.4428C8.27998 10.0828 8.03998 9.84281 7.55998 9.60281C5.15998 8.40281 2.75998 7.20281 0.359979 6.00281C-2.06111e-05 5.76281 -0.120021 5.40281 0.119979 5.16281C0.239979 5.04281 0.359979 5.04281 0.479979 4.92281C2.63998 4.32281 4.91998 3.60281 7.07998 3.00281C10.44 2.04281 13.8 0.962812 17.16 0.0028125C17.28 0.0028125 17.4 0.0028125 17.4 -0.117188C17.76 0.0028125 18 0.242812 18 0.602812ZM16.44 2.28281C16.32 2.40281 16.32 2.40281 16.32 2.40281C13.92 4.80281 11.64 7.08281 9.23998 9.48281C9.11998 9.60281 9.11998 9.60281 9.23998 9.72281C10.32 11.7628 11.28 13.8028 12.36 15.8428C12.36 15.8428 12.36 15.9628 12.48 15.9628C13.8 11.5228 15.12 6.96281 16.44 2.28281ZM15.72 1.56281C15.6 1.56281 15.6 1.56281 15.72 1.56281C11.04 2.88281 6.47998 4.20281 1.91998 5.64281C2.03998 5.76281 2.15998 5.76281 2.15998 5.76281C4.19998 6.72281 6.11998 7.80281 8.15998 8.76281C8.27998 8.88281 8.39998 8.76281 8.51998 8.64281C10.8 6.36281 13.08 4.08281 15.48 1.68281C15.6 1.68281 15.6 1.68281 15.72 1.56281Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_9837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignToImg);
export default __webpack_public_path__ + "static/media/assignToImg.c69ca8e9fda3acb0e8a951a251189992.svg";
export { ForwardRef as ReactComponent };